import { z as zod } from 'zod';

import {
  isAddressLandmarkValid,
  isAddressLatLngValid,
} from '../helpers/VMHelper';

export const enum AddressType {
  pickup = 'pickupAddress',
  drop = 'dropAddress',
}

export const extAddressSchema = zod.object({
  landmark: zod.string(),
  location: zod.object({
    lat: zod.number(),
    lng: zod.number(),
  }),
  addressDetails: zod.object({
    state: zod.string().optional(),
    city: zod.string().optional(),
    pincode: zod.string().optional(),
    locality: zod.string().optional(),
    subLocality: zod.string().optional(),
  }),
});

export const schema = zod.object({
  [AddressType.pickup]: extAddressSchema
    .refine(isAddressLandmarkValid, {
      message: 'Please enter the valid address',
    })
    .refine(isAddressLatLngValid, {
      message: 'No result found',
    }),
  [AddressType.drop]: extAddressSchema
    .refine(isAddressLandmarkValid, {
      message: 'Please enter the valid address',
    })
    .refine(isAddressLatLngValid, {
      message: 'No result found',
    }),
});

export type FormData = zod.infer<typeof schema>;
